import { render, staticRenderFns } from "./Icons.vue?vue&type=template&id=574f00d5"
import script from "./Icons.vue?vue&type=script&lang=js"
export * from "./Icons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('574f00d5')) {
      api.createRecord('574f00d5', component.options)
    } else {
      api.reload('574f00d5', component.options)
    }
    module.hot.accept("./Icons.vue?vue&type=template&id=574f00d5", function () {
      api.rerender('574f00d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/origin/Icons.vue"
export default component.exports